import { render, staticRenderFns } from "./AWeblink.vue?vue&type=template&id=c2788f6c&scoped=true&"
import script from "./AWeblink.vue?vue&type=script&lang=ts&"
export * from "./AWeblink.vue?vue&type=script&lang=ts&"
import style0 from "./AWeblink.vue?vue&type=style&index=0&id=c2788f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2788f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
